import * as React from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Slide, {SlideProps} from '@mui/material/Slide';
import {TransitionProps} from '@mui/material/transitions';
import List from '@mui/material/List';
import Foodtabs from "./Foodtabs";
import {useEffect} from "react";
import hoistoryStore from "../store/historyStore";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export default function HistoryFoodInput(props :any) {
  const [value, setValue] = React.useState('one');
  const [state, setState] = React.useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade,
  });
  const storeData: any = hoistoryStore();
  
  useEffect(() => {
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleClick =
    (
      Transition: React.ComponentType<
        TransitionProps & {
          children: React.ReactElement<any, any>;
        }
      >,
    ) =>
    () => {
      setState({
        open: true,
        Transition,
      });
    };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
  };
  
  const handleSave = () => {
    setState({
      ...state,
      open: false,
    });
    props.handleComplete(value);
  };

  const action = (
    <React.Fragment>
      <Box sx={{  }}>
        <Stack >
          <Typography 
            sx={{
              color:'#333',
              fontSize:18,
              fontWeight:700,
              textAlign:'center',
              mb:'20px',
              borderBottom:'1px solid #ddd',
              pb:2
            }}
          >
            오늘의 음식을 입력하세요
          </Typography>
          
          <Box>
            <List sx={{m:0, border:'1px solid #ccc', p:0, borderRadius:4,}}>
               <Foodtabs />
            </List>
          </Box>
        </Stack>
      </Box>
      
      <Stack  direction={'row'} spacing={2} sx={{mt:2}}>
        <EditButton onClick={handleClose}>
          취소
        </EditButton>
        <EditButton onClick={handleSave} sx={{backgroundColor: '#EF8322',color:'#fff'}}>
          저장
        </EditButton>
      </Stack>
    </React.Fragment>
  );

  
  
  return (
    <Stack sx={editbtn} >
       <EditButton onClick={handleClick(SlideTransition)}>입력 하기</EditButton>
      <Snackbar
        open={state.open}
        onClose={handleClose}
        TransitionComponent={state.Transition}
        message={action}
        key={state.Transition.name}
        sx={{left:'0 !important', right:0, bottom:'0 !important', width:'100%',
          '& .MuiSnackbarContent-root' :{
            bgcolor:'#fff',
            display:'block',
            width:'100%',
            padding:'15px',
            boxSizing:'border-box',
            borderRadius:'20px 20px 0 0',
            boxShadow:'0px -3px 8px 2px rgba(0,0,0,.3)',
            color:'#555'
          }
        }}
      />
    </Stack>
  );
}

const search_Fome_Style = {
  m:'10px auto', 
  p: '0px 10px', 
  display: 'flex', 
  alignItems: 'center', 
  width: '100%', 
  borderRadius:'24px',
  boxShadow:'inset 0 0 4px rgba(0,0,0,0.4)',
  boxSizing:'border-box'
};

const bottomBtn ={
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight:700,
  padding: '10px 20px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  color:'#fff',
  width:'100%',
  borderRadius:'20px',
  mt:3,
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color:'#fff'
  },
}

const editbtn = {
  width:'49%',
  alignItems: 'center'
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight:700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border:'1px solid #EF8322',
  borderRadius:'20px',
  color:'#EF8322',
  margin:'10px 0 30px 0',
  width:'90%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color:'#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});